import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DtoApiInfo, DtoNewMenu } from '@common';
import { environment } from '../../../environments/environment';
import { Observable, of, tap } from 'rxjs';
import { versionInfo } from './version-info';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  //#region private fields ----------------------------------------------------
  private httpClient: HttpClient;
  private menu: DtoNewMenu | null;
  //#endregion

  //#region Constructor -------------------------------------------------------
  public constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
    this.menu = null;
  }
  //#endregion

  //#region public methods ----------------------------------------------------
  public getApiInfo(): Observable<DtoApiInfo> {
    return this.httpClient.get<DtoApiInfo>('api/system/info');
  }

  public getClientVersion(): string {
    return versionInfo.version;
  }

  public getClientEnvironment(): string {
    return environment.production ? '' : environment.environment.toUpperCase();
  }

  public getMenu(): Observable<DtoNewMenu> {
    if (this.menu) {
      return of(this.menu);
    } else {
      return this.httpClient.get<DtoNewMenu>('/api/site/new-menu').pipe(
        tap((resp: DtoNewMenu) => {
          this.menu = resp;
        })
      );
    }
  }
  //#endregion
}
